<template>
  <div>
    <McTable v-bind="propsData" />
  </div>
</template>

<script>
import McTable from './index.vue'
export default {
  components: {
    McTable,
  },
  props: {
    propsData: {
      default: {
        searchable: true,
        apiClient: {
          get: () => {
            return {
              data: {
                paginated_result: [
                  {
                    id: 1,
                    name: 'tes1',
                  },
                  {
                    id: 2,
                    name: 'tes 2',
                  },
                ],
                ids: [1, 2],
              },
              metadata: {
                page: 1,
                total_count: 2,
              },
            }
          },
        },
        fields: [
          {
            label: 'id',
            key: 'id',
          },
          {
            label: 'nama',
            key: 'name',
          },
        ],
      },
    },
  },

  created() {
    if (this.$route.query?.props) {
      const getData = this.propsData.apiClient.get

      this.propsData.apiClient.get = () => {
        return getData
      }

      this.propsData.apiClient.delete = (key) => {
        const { data } = this.propsData.apiClient.get()
        const filteredResult = data.paginated_result.filter((e) => e.id != Number(key))
        const filteredResultIds = data.ids.filter((e) => e != Number(key))
        this.propsData.apiClient.get = () => {
          return {
            data: {
              paginated_result: filteredResult,
              ids: filteredResultIds,
            },
            metadata: {
              page: 1,
              total_count: filteredResultIds.length,
            },
          }
        }
      }
    }
  },
}
</script>
